// Contains general misc constants
export const MILL_SECONDS = 1000; // 1 Second in Milliseconds
